import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 32 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.7, delay, ease: [0.16, 1, 0.3, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export default function SectionHeading({ number, title, sub, id }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
      className="mb-14"
    >
      <div className="flex items-end gap-5 border-b border-white/10 pb-6">
        <span
          data-testid={`section-${id}-number`}
          className="font-jbmono text-sm text-neon pb-2"
        >
          {number}
        </span>
        <h2 className="font-bebas text-5xl sm:text-7xl leading-none tracking-tight">
          {title}
        </h2>
        {sub && (
          <span className="ml-auto hidden sm:block pb-2 font-jbmono text-[11px] uppercase tracking-[0.25em] text-white/40">
            {sub}
          </span>
        )}
      </div>
    </motion.div>
  );
}
